"use strict";

var recaptchaCheck = require("../helpers/recaptchaCheck");

/**
* Handles the submission of the email signup form, preventing the default form submission behavior,
* and sending an AJAX request to the server with the form data. Displays a loading spinner during
* the request and handles success or error responses accordingly.
*
* @param {Event} e - The event object associated with the form submission.
* @returns {void}
*/
function handleFormSubmit(e) {
    e.preventDefault();

    const $form = $(this);
    const $emailSignupModal = $(".js-emailSignupModal");
    const $errorElement = $(".js-mit-email-signup-error-message");
    const leadSource = $form.data("lead-source");
    const sourceCode = $form.data("source-code");
    const gatedContent = $form.data("gated-content");
    const pid = $(".product-detail[data-pid]").data("pid");

    recaptchaCheck.getRecaptchaToken(function (token) {
        $form.find("input[name='gRecaptchaResponse'").val(token);

        $emailSignupModal.spinner().start();

        var formURL = $form.attr("action");

        // Construct URL with parameters
        const urlParams = {};

        if (leadSource && leadSource.length > 0) {
            urlParams.lead_source = leadSource;
        }

        if (sourceCode && sourceCode.length > 0) {
            urlParams.source_code = sourceCode;
        }

        if (pid && pid.length > 0) {
            urlParams.pid = pid;
        }

        if (gatedContent) {
            urlParams.gated_content = gatedContent;
        }

        formURL = constructUrlWithParams(formURL, urlParams);

        $.ajax({
            url: formURL,
            type: "post",
            data: $form.serialize(),
            success: function (data) {
                handleAjaxSuccess(data, $form, $errorElement);
            },
            error: function (err) {
                console.error("An error occurred during the AJAX request:", err);
                $emailSignupModal.spinner().stop();
            }
        });
    }, "newsletter_signup");
}

const constructUrlWithParams = (baseUrl, params) => {
    const queryParams = new URLSearchParams(params);
    return baseUrl + (baseUrl.includes("?") ? "&" : "?") + queryParams.toString();
};

/**
* Handles the success response from an AJAX request for email signup.
*
* This function processes the response data from an AJAX call, updating the UI
* based on whether there was an error or not. If an error is present in the data,
* it displays the error element. Otherwise, it resets the form, hides the modal content,
* and shows a success message.
*
* @param {Object} data - The response data from the AJAX request. It should contain an 'error' property.
* @param {jQuery} $form - The jQuery object representing the form that was submitted.
* @param {jQuery} $errorElement - The jQuery object representing the element used to display error messages.
*/
function handleAjaxSuccess(data, $form, $errorElement) {
    if (data.error) {
        $errorElement.removeClass("d-none");
    } else {
        $form.trigger("reset");
        $form.closest(".modal-content").addClass("d-none");
        $errorElement.addClass("d-none");
        $(".js-mit-email-signup-success").removeClass("d-none");
    }

    $(".js-emailSignupModal").spinner().stop();
}

/**
* Resets the modal to its initial state by showing the modal content and hiding any success or error messages.
* This function is typically used to prepare the modal for a new interaction or submission.
*/
function resetModal() {
    $(this).find(".modal-content").removeClass("d-none");
    $(".js-mit-email-signup-success").addClass("d-none");
    $(".js-mit-email-signup-error-message").addClass("d-none");
    $("html").css("overflow", "");
}

module.exports = {
    methods: {
        handleAjaxSuccess,
        resetModal
    },
    initEmailSignup: function () {
        $(document).ready(function () {
            const $checkbox = $(".js-mit-checkbox-disclaimer");

            $checkbox.each(function () {
                const $this = $(this);
                const $dynamicDisclaimer = $this.next();
                const $invalidFeedBack = $this.siblings(".invalid-feedback");

                $this.prependTo($dynamicDisclaimer);
                $invalidFeedBack.appendTo($dynamicDisclaimer);
            });

            $(".js-mit-email-signup-form").on("submit", handleFormSubmit);
        });

        $(document).on("show.bs.modal", ".js-emailSignupModal", function () {
            $("html").css("overflow", "hidden");
        });

        $(document).on("hidden.bs.modal", ".js-emailSignupModal", resetModal);
    },
};
